module.exports = __webpack_public_path__ + "static/media/back-arrow.4fe60c3f.svg";